import { toAbsoluteUrl } from "../../helpers/assetHelper";
import {
  ExtraDataPreset,
  TableExtraItemType,
} from "./tableContext/TableContext";
import { BadgesCell, SubtitleCell, TitleCell } from "./components/TableItem";
import themeConfig from "../../theme/themeConfig.json";

function TableItemExtra({
  extraData,
  extraDataPreset = "default",
  extraDataRowIndex,
  extraDataRowsCount,
}: {
  extraData: TableExtraItemType[];
  extraDataPreset?: ExtraDataPreset;
  extraDataRowIndex: number;
  extraDataRowsCount: number;
}) {
  const borderColor = "#b8c2cc";
  const accentColor = themeConfig.colors.brand.DEFAULT;
  const isFirstRow = extraDataRowIndex === 0;
  const isLastRow = extraDataRowIndex === extraDataRowsCount - 1;

  const getPresetCellProps = (index: number) => {
    const isFirstCell = index === 0;
    const isLastCell = index === extraData.length - 1;

    if (extraDataPreset === "bordered") {
      return {
        className: "",
        style: {
          boxShadow: `inset 0 1px 0 ${borderColor}, inset 0 -1px 0 ${borderColor}`,
        },
      };
    }

    if (extraDataPreset === "indented") {
      return {
        className: isFirstCell ? "pl-8" : "",
        style: undefined,
      };
    }

    if (extraDataPreset === "highlighted") {
      return {
        className: "",
        style: { backgroundColor: "#fff8dd" },
      };
    }

    if (extraDataPreset === "grouped") {
      const shadows = [
        isFirstRow ? `inset 0 1px 0 ${borderColor}` : "",
        isLastRow ? `inset 0 -1px 0 ${borderColor}` : "",
        isFirstCell ? `inset 3px 0 0 ${accentColor}` : "",
        isLastCell ? `inset -1px 0 0 ${borderColor}` : "",
      ].filter(Boolean);

      return {
        className: isFirstCell ? "pl-8" : "",
        style: {
          backgroundColor: "#f5f8fa",
          boxShadow: shadows.join(", "),
        },
      };
    }

    return { className: "", style: undefined };
  };

  return (
    <tr>
      {extraData?.map((item, index) => {
        const config = item?.config ?? {};
        const preset = getPresetCellProps(index);

        return (
          <td
            key={index}
            {...config}
            className={`px-4 ${preset.className} ${config.className ?? ""}`}
            style={{
              backgroundColor: "#f5f8fa",
              ...preset.style,
              ...config.style,
            }}>
            <div className="flex items-center">
              {item?.img && (
                <div className="mr-5 h-[50px] w-[50px] shrink-0">
                  <img
                    src={toAbsoluteUrl(item.img)}
                    alt={item?.title?.toString()}
                    className="mr-3 h-full w-full rounded-control object-cover"
                  />
                </div>
              )}
              <div className="flex justify-start flex-col">
                {item?.title !== undefined && item?.title !== null && (
                  <TitleCell
                    title={item.title}
                    titleStyle={item.titleStyle}
                    titleClassName={item.titleClassName}
                  />
                )}
                {item?.subtitle !== undefined && item?.subtitle !== null && (
                  <SubtitleCell
                    subtitle={item.subtitle}
                    subtitleStyle={item.subtitleStyle}
                    subtitleClassName={item.subtitleClassName}
                  />
                )}
                {item?.badges && item.badges.length > 0 && (
                  <BadgesCell badges={item.badges} />
                )}
              </div>
            </div>
          </td>
        );
      })}
    </tr>
  );
}

export default TableItemExtra;
